<template>
    <div>
        <div class="file-list" v-if="!isHideFileList">
            <div v-for="(file,index) in fileList" :key="index" class="file-item clearfix">
                <div class="file-name" v-if="isOnlyImage">
                    <img :src="file.imgUrl" class="img-file" @click="reviewImg(file.imgUrl)">
                </div>
                <div class="file-name" v-else>
                    <i class="el-icon-document"></i>{{file.fileOldName}}
                </div>
                <div class="file-button" v-if="canEdit">
                    <i class="el-icon-close" @click="fileListHandleRemove(file.fileOldName,index)"></i>
                </div>
            </div>
        </div>
        <el-upload  v-if="canEdit"
                    class="upload-demo"
                    :action="uploadApi"
                    :show-file-list="false"
                    :on-progress="fileListHandleProgress"
                    :on-success="fileListHandleSuccess"
                    :on-error="fileListHandleError"
                    :before-upload="beforeFileUpload"
                    :multiple="noMany ? false : true">
            <el-button size="mini" type="primary"
                       :loading="fileListLoading"
                       :disabled="fileListDisabled">
                {{(fileListLoading)?'上传中...':'点击上传'}}
            </el-button>
            <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M</div>
        </el-upload>
        <el-dialog title="图片预览" :visible.sync="showImg"  append-to-body>
            <img :src="imgUrl">
        </el-dialog>
    </div>
</template>

<script type="text/babel">
    import Vue from 'vue'
    import util from '@/util/'
    export default Vue.component('page-upload', {
        data () {
            return {
                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadApi: `${util.baseUrl}rest/file/down`,
                fileList: [],
                fileType: this.attachmentType,
                fileSubType: this.attachmentSubType,
                fileListLoading: false,
                fileListDisabled: false,
                canEdit: this.editFlag,
                isHideFileList: this.isHideList || '',//true,隐藏文件列表，false，显示文件列表
                noMany: this.notMany || '',//true,不支持上传多个文件，false，支持上传多个文件
                isOnlyImage: this.onlyImg || false, //true 只能上传图片，false 任意类型
                showImg: false,
                imgUrl: '',
                cansubmit: this.canSubmit,//文件是否已上传成功
                limitLength: this.fileLength
            }
        },
        props: ['attachmentType','files','editFlag','isHideList','notMany', 'onlyImg', 'attachmentSubType','canSubmit','fileLength'],
        methods: {
            fileListHandleProgress(){
                this.fileListLoading = true;
                this.fileListDisabled = true;
            },
            fileListHandleSuccess(response) {
                let that = this;
                that.fileListLoading = false;
                that.fileListDisabled = false;
                if (this.fileList.length >= this.limitLength) {
                    this.$alert(`当前限制上传` + this.limitLength + `个文件`, '文件数量限制！', {type: 'error'});
                    return false
                } else{
                    if(response.basefiles.length){
                        let obj = {};
                        let f = response.basefiles[0];
                        obj.fileOldName = f.fileoldname;
                        obj.fileName = f.filename;
                        obj.filePath = f.filepath;
                        obj.fileSize = f.filesize;
                        obj.fileType = f.filetype;
                        obj.sort = f.sort;
                        obj.name = f.fileoldname;
                        if(that.noMany){
                            that.fileList=[];
                            that.fileList.push(obj);
                        } else {
                            that.fileList.push(obj);
                        }
                        that.cansubmit = true;
                        that.$emit('finishUpload',{
                            fileList: that.fileList,
                            cansubmit: that.cansubmit
                        });
                        that.$message.success('上传成功');
                        console.log(that.fileList);
                    }else{
                        that.$message.error('上传失败');
                    }
                }
            },
            fileListHandleError(response){
                let that = this;
                //console.log('上传失败',response);
                this.cansubmit = true;
                this.$message({message:'上传出错，请稍后再试。',type:'error'});
                that.fileListLoading = false;
                that.fileListDisabled = false;
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            fileListHandleRemove(fname,index){
                let that = this;
                that.$confirm('确定移除'+fname+'?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.fileList.splice(index,1);
                            that.$emit('finishUpload',{
                                fileList: that.fileList,
                                cansubmit: that.cansubmit
                            });
                        }
                    }
                });
            },
            fileListHandleDownload(file){
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.$root.downloadFile({
                                attachName: file.attachName,
                                attachPath: file.attachPath
                            })
                        }
                    }
                });
            },
            beforeFileUpload(file){
                this.cansubmit = false;
                this.$emit('finishUpload',{
                    fileList: this.fileList,
                    cansubmit: this.cansubmit
                });
                const isLt100M = file.size / 1024 /1024 < 100;
                    if (this.fileList.length >= this.limitLength) {
                        this.$alert(`当前限制上传` + this.limitLength + `个文件`, '文件数量限制！', {type: 'error'});
                        return false
                    }else if(!util.allowUpload(file.name)){
                        this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`,'文件类型不支持，已取消上传！',{ type: 'error' })
                        return false
                    }else if (!isLt100M) {
                        this.$alert('上传附件大小请不要超过100M','文件过大！',{ type: 'error' })
                        return isLt100M;
                    }else{
                        return true
                }
            },
            reviewImg(url){
                // this.imgUrl = url;
                // this.showImg = true;
            }
        },
        mounted(){
            this.fileList = this.files;
            this.cansubmit = this.canSubmit;
        }
    })

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
    .file-list{}
    .file-list .file-item{
        position: relative;
    }
    .file-list .file-item:hover{
        background: rgb(245,247,250);
    }
    .file-list .file-name{

    }
    .file-list .file-button{
        position: absolute;
        top: 0;
        right: 10px;
    }
    .img-file {
        height: 100px;
    }
    /*.img-file:hover {*/
    /*cursor: pointer;*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/components/MyUpload.vue